module.exports = __webpack_public_path__ + "static/media/worldLoading.98aad670.svg";